module.exports = __webpack_public_path__ + "img/accordion.5ccc85c1.svg";